import { BBDTag, GraviButton, Horizontal, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Avatar, Tooltip } from 'antd'
import type * as React from 'react'

import type { CostRevenueType, TopItem } from '../../types'

interface SummaryCardProps {
  label: string
  value: string
  percentage: string
  items: TopItem[]
  title?: string
  topLevelLinkLabel: string
  type: string
  costRevenue: CostRevenueType
}

/**
 * A reusable card component for displaying metric summaries
 */
export function SummaryCard({
  label,
  value,
  percentage,
  items,
  title = 'Top Customers',
  topLevelLinkLabel,
  type,
  costRevenue,
}: SummaryCardProps) {
  return (
    <Vertical bg='default' border='all' borderRadius='6px' flex={1}>
      <Vertical flex='0' style={{ overflow: 'visible' }} border='bottom' className='p-3'>
        <Texto category='p2' appearance='hint'>
          {label}
        </Texto>
        <Horizontal className='pt-2' justifyContent='space-between' verticalCenter>
          <Texto weight='bold' category='h3'>
            {value}
          </Texto>
          <BBDTag>{percentage}</BBDTag>
        </Horizontal>
      </Vertical>

      <Vertical>
        <Horizontal border='bottom' className='px-3 py-2' verticalCenter alignItems='space-between'>
          <Texto style={{ alignItems: 'center', display: 'flex', flex: 1 }} weight='bold' category='h5'>
            <MaterialIcon style={{ color: 'var(--theme-warning)' }} fill className='mr-2' icon='trophy' />
            {title}
          </Texto>
        </Horizontal>

        {items.length > 0 ? (
          items.map((item, index) => (
            <Horizontal
              key={`${type}-${item.name}`}
              justifyContent='space-between'
              className='px-3 py-2'
              gap={8}
              style={{
                borderBottom: index !== items.length - 1 ? '1px solid var(--gray-200)' : 'none',
              }}
              verticalCenter
            >
              <Horizontal gap={8} verticalCenter flex={1}>
                <Avatar
                  style={{
                    backgroundColor: 'var(--theme-color-2-dim)',
                    color: 'var(--theme-color-2)',
                  }}
                  size={18}
                >
                  {index + 1}
                </Avatar>
                <Texto
                  style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {item.name}
                </Texto>
              </Horizontal>
              <Texto weight='bold' category='p2'>
                {item.value}
              </Texto>
            </Horizontal>
          ))
        ) : (
          <Vertical
            verticalCenter
            bg='elevated'
            border='all'
            borderRadius='6px'
            className='p-3 my-2'
            horizontalCenter
            flex={1}
          >
            <Texto category='p2' appearance='hint'>
              No data available
            </Texto>
          </Vertical>
        )}
      </Vertical>
    </Vertical>
  )
}
